import { Flex, Text } from "@chakra-ui/react";
import { useUI } from "providers/UIProvider";


interface EditDetailsTotalPrice {
    totalPrice: number
}

const EditDetailsTotalPrice: React.FC<EditDetailsTotalPrice> = ({ totalPrice }) => {

    const { T } = useUI();

    return (
        <Flex
            padding="16px 23px"
            justifyContent="space-between"
            borderBottom="1px solid #E9F2FD"
            width="100%"
            alignItems="center"
            height="50px"
        >
            <Text fontSize="12px">{T("booking.details.modal.booking.total.price")}</Text>
            <Flex>
                <Text
                    style={{
                        padding: "1px 5px",
                        backgroundColor: "#046CEC",
                        color: "#FFF",
                        borderRadius: "16px",
                        border: "1px solid #046CEC",
                        fontWeight: "500",
                        fontSize: "18px",
                        minWidth: "75px",
                        textAlign: "center"
                    }}
                    id="totalPrice"
                >{totalPrice}₾</Text>
            </Flex>
        </Flex>
    )
};

export default EditDetailsTotalPrice;